class PaymentContract {
	id = null;
	note = null;
	date = null;
	partner_id = null;
	candidate_id = null;
	loyalty_points = 0;
	total = 0;
	total_bruto = 0;
	payed = 0;
	debt = 0;
	discount = 0;
	contract_type = 'partner';
	payment_contract_type_id = 1;
	payment_contract_status_id = 1;
	status_name = 'Otvoren';
	loyalty_discount = false;
	items = [];
	active = true;
	vat_exists = true;

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default PaymentContract;
